import React, { useEffect } from 'react';
import ICommonFormProps from '../../yoello-lib/modules/dynamicForms/interfaces/ICommonFormProps';
import FormSwitch from "../../yoello-lib/modules/dynamicForms/FormComponents/FormSwitch";
import { TimingCheckbox } from "./ui/TimingCheckbox";
import { EnableTimes } from "./ui/EnableTimes";
import { useStyles } from "./styles";
import { EnableTime, MenuTimingItem } from './types';
import FormElement from '../../yoello-lib/modules/dynamicForms/FormElement';


export function TimingMenusContainer(props: ICommonFormProps) {
  const classes = useStyles();

  useEffect(() => {
    let timings = props.formProps?.menuTiming ?? [];
    if (props?.formProps?.enabled === false) {
      timings = undefined;
    }
    if (props.setValue) {
      props.setValue(props.keyName, timings, { shouldDirty: true });
    }
    // eslint-disable-next-line
  }, [props.formProps?.enabled])


  function onChangeHandler(value: any) {
    props.formProps?.setMenuTimingEnabled(value)
  }
  function onChange(keyName: string, enabled: boolean) {
    const newMenuTiming = [...props.formProps?.menuTiming];
    newMenuTiming.forEach(({ key }: MenuTimingItem, index: number) => {
      if (key === keyName) {
        newMenuTiming[index] = {
          ...newMenuTiming[index],
          enabled
        };
      }
    })
    props.formProps?.setMenuTiming(newMenuTiming);
  }
  function addOrRemoveTime(day: string, index?: number, status?: boolean) {
    // status true for adding
    const newMenuTiming = [...props.formProps?.menuTiming];
    // eslint-disable-next-line
    newMenuTiming.forEach(({ key, value }: MenuTimingItem) => {
      if (key === day) {
        if (status) {
          value.push({ start: "", end: "" })
        }
        else {
          if (status === undefined && index !== undefined) {
            value.splice(index, 1)
          } else {
            value.splice(0, 1, { start: "", end: "" })
          }
        }
      }
    })
    if (props.setValue) {
      props.setValue(props.keyName, newMenuTiming, { shouldDirty: true });
    }

    props.formProps?.setMenuTiming(newMenuTiming);
  }
  function updateTimingArray(keyName: string, timingArrayIndex: number, value: EnableTime) {
    const newMenuTiming = [...props.formProps?.menuTiming];
    newMenuTiming.forEach(({ key }: MenuTimingItem, index: number) => {
      const newValues = [...newMenuTiming[index].value];
      newValues[timingArrayIndex] = value;
      if (key === keyName) {
        newMenuTiming[index] = {
          ...newMenuTiming[index],
          value: [...newValues]
        };
      }
    })
    if (props.setValue) {
      props.setValue(props.keyName, newMenuTiming, { shouldDirty: true });
    }

    props.formProps?.setMenuTiming(newMenuTiming);
  }
  function getWeekDays() {
    return props.formProps?.menuTiming && props.formProps?.menuTiming.map(({ key, value, enabled }: MenuTimingItem) => {
      return <div key={key} className={classes.WorkDays} style={key === "Sunday" ? { borderBottom: "unset" } : undefined}>
        <TimingCheckbox keyName={key} onChange={onChange} addTime={addOrRemoveTime} enabled={enabled} />
        <EnableTimes timingArray={value} day={key} removeTime={addOrRemoveTime} updateTimingArray={updateTimingArray} enabled={enabled} />
      </div>
    })
  }

  return (
    <FormElement {...props}>
      <div className={classes.TimingMenuContainer}>
        <label htmlFor="">{props.label}</label>
        <div data-component-name="MENU_TIMING_ENABLING">
          <FormSwitch {...props} register={undefined as any} label={""} keyName={"timings_enabled"} value={props.formProps?.enabled}
            formProps={{ onValueChange: (value: any) => onChangeHandler(value) }} />
          <p>
            {props.formProps?.secondLabel}
          </p>
        </div>
        {props.formProps?.enabled && <section>
          <main>
            {getWeekDays()}
          </main>
        </section>}
      </div>
    </FormElement>
  )
}
